<template>
  <div class="filter-health-container">
    <div class="sac__font-18 med">
      Air Filter Health
    </div>
    <div class="small-card-container margin-top-16">
      <div
        v-for="(item, idx) in filterList"
        :key="idx"
        :class="['card', item.currentLifePercent < 10 ? 'low-health' : '']"
      >
        <div>
          <div class="sac__font-16 med">
            {{ item.location }}
          </div>
          <div class="sac__font-14 n60 margin-top-4">
            {{ item.brand }} | {{ `${item.width} x ${item.height} x ${item.thickness}` }}
          </div>
          <div class="sac__font-14 n60 margin-top-4">
            MERV: {{ item.merv }}
          </div>
          <div class="sac__font-14 n60 margin-top-4">
            Last Replaced {{ formatDate(item.lastReplaced) }}
          </div>
          <div class="grid-column ai-c jc-b margin-top-16">
            <div class="grid-column ai-e jc-b gap-5">
              <div class="filter-health" :style="getFilterHeight(item.currentLifePercent).heightRef" />
              <img
                src="@shared/assets/img/performance-summary/filter.svg"
                alt="filter"
                class="img-size-28"
              >
              <img
                v-if="item.did"
                src="@shared/assets/img/performance-summary/sensor-img.svg"
                alt="filter"
                class="img-size-24"
              >
            </div>
            <div class="sac__font-18 semi-bold" :style="getFilterHeight(item.currentLifePercent).textRef">
              {{ item.currentLifePercent }} %
            </div>
          </div>
        </div>
        <div
          v-if="item.did"
          class="sac__font-14 n60"
        >
          Sensor Attached
        </div>
        <div
          v-else
          class="sac__font-14 n60"
        >
          No Sensor Attached
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'FilterList',
  computed: {
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
      airFilterList: (state) => state.customerDetail.filters,
    }),
    filterList() {
      return this.airFilterList.filter((x) => x.uid === this.selectedUnit.uid);
    },
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('MMM DD, YYYY');
      }
      return '--';
    },
    getFilterHeight(percent) {
      let color;
      const elementHeight = `${(28 * percent) / 100}px`;
      if (percent < 10) {
        color = '#FF5B52';
      } else if (percent >= 10 && percent < 50) {
        color = '#FFAB00';
      } else if (percent >= 50) {
        color = '#4CD87D';
      }
      return {
        heightRef: { height: elementHeight, backgroundColor: color },
        textRef: { color },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.filter-health-container {
  .small-card-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(20rem, 100%), 1fr));
    gap: 1.5rem;
    .card {
      border-radius: 6px;
      padding: 1rem;
      background-color: $N5;
      height: 12rem;
      display: grid;
      align-content: space-between;
      &.low-health {
        border:  2px solid $TOMATO90;
      }
      .filter-health {
        width: 5px;
        border-radius: 2px;
      }
    }
  }
}
</style>
